import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Icon, notification } from "antd";
import axios from "axios";

import RelatorioIranduba from "../EstabelecimentoRelatorio/RelatorioIranduba";
import DrawerRelatorioIranduba from "../Drawers/DrawerRelatorioIranduba";
import DrawerRelatorioIrandubaFundamental from "../Drawers/DrawerRelatorioIrandubaFundamental";
import ModalRelatorioIranduba from "../Modal/ModalRelatorioIranduba";
import ModalRelatorioIrandubaFundamental from "../Modal/ModalRelatorioIrandubaFundamental";

const openNotificationWithIcon = (type, message, description) => {
    notification[type]({
        message: message,
        description: description
    });
};

const RelatoriosIranduba = () => {
    const [relatorios, setRelatorios] = useState([]);
    const [isTipoInfantil, setIsTipoInfantil] = useState(false);
    const [relatorioId, setRelatorioId] = useState(null);
    const [drawerVisible, setDrawerVisible] = useState(false);
    const [modalVisible, setModalVisible] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const montarBotaoVoltar = () => {
        if (localStorage.getItem("opcao_voltar") != null) {
            const opcaoInfo = JSON.parse(localStorage.getItem("opcao_voltar"));
            return (
                <>
                    <Link
                        to={opcaoInfo.link_voltar_curso ? opcaoInfo.link_voltar_curso : opcaoInfo.link_voltar}
                        className="botao-secundario botao-secundario-redondo"
                        onClick={() => opcaoInfo.id_curso && localStorage.setItem("codigo_curso", opcaoInfo.id_curso)}
                        style={{ marginRight: 10, display: "flex", justifyContent: "center", alignItems: "center" }}
                    >
                        <Icon type="arrow-left" />
                    </Link>
                </>
            );
        }
    };

    const handleEditarRelatorio = id => {
        setDrawerVisible(true);
        setRelatorioId(id);
    };

    const handleViewRelatorio = id => {
        setModalVisible(true);
        setRelatorioId(id);
    };

    const handleCloseDrawer = () => {
        setDrawerVisible(false);
        setRelatorioId(null);
    };

    const handleCloseModal = () => {
        setModalVisible(false);
        setRelatorioId(null);
    };

    const carregarRelatorios = () => {
        setIsLoading(true);

        axios({
            method: "get",
            url: "/api/relatorio-individual/carregar-relatorios-individuais",
            params: {
                disciplinaId: localStorage.getItem("codigo_curso")
            }
        })
            .then(response => {
                setRelatorios(response.data.relatorios);
                setIsTipoInfantil(response.data.tipoRelatorio);
            })
            .catch(error => {
                openNotificationWithIcon("error", "Erro", error.response.data || "Ocorreu um erro ao carregar os relatórios.");
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    const atualizarListagem = () => {
        setDrawerVisible(false);
        setRelatorioId(null);
        carregarRelatorios();
    };

    const handleDelete = () => {
        setModalVisible(false);
        setRelatorioId(null);
        carregarRelatorios();
    };

    useEffect(() => {
        carregarRelatorios();
    }, []);

    return (
        <>
            <div className="container container-body">
                <div className="turma-visao-geral">
                    <div className="controlos controlos-fundo ">
                        <div className="bloco-esquerda">
                            <span className="titulo-pagina">Relatório Individual</span>
                        </div>
                        <div className="bloco-direita">
                            <Link
                                to="#"
                                className="botao-principal botao-principal-redondo"
                                title="Novo atendimento"
                                onClick={() => setDrawerVisible(true)}
                            >
                                +
                            </Link>
                            {montarBotaoVoltar()}
                        </div>
                    </div>
                    <div className="bloco">
                        <div className="bloco-relatorios">
                            <div className="titulo-bloco-relatorios">Relatórios Criados</div>
                            <div className="lista-relatorios">
                                {relatorios.length === 0 &&
                                    'Nenhum relatório criado ainda. Clique no botão " + " para criar seu primeiro relatório.'}
                                {relatorios.map(relatorio => (
                                    <React.Fragment key={relatorio.id}>
                                        <RelatorioIranduba
                                            onEdit={handleEditarRelatorio}
                                            onView={handleViewRelatorio}
                                            relatorio={relatorio}
                                            isTipoInfantil={isTipoInfantil}
                                        />
                                    </React.Fragment>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {isTipoInfantil ? (
                <>
                    <DrawerRelatorioIranduba
                        id={relatorioId}
                        visible={drawerVisible}
                        onClose={handleCloseDrawer}
                        atualizarListagem={atualizarListagem}
                    />
                    <ModalRelatorioIranduba id={relatorioId} visible={modalVisible} onCancel={handleCloseModal} onDelete={handleDelete} />
                </>
            ) : (
                <>
                    <DrawerRelatorioIrandubaFundamental
                        id={relatorioId}
                        visible={drawerVisible}
                        onClose={handleCloseDrawer}
                        atualizarListagem={atualizarListagem}
                    />
                    <ModalRelatorioIrandubaFundamental
                        id={relatorioId}
                        visible={modalVisible}
                        onCancel={handleCloseModal}
                        onDelete={handleDelete}
                    />
                </>
            )}
        </>
    );
};

export default RelatoriosIranduba;
